export const MARKED_AS_COMPLETED_UPDATE = 'MARKED_AS_COMPLETED_UPDATE'
export const MARKED_AS_COMPLETED_UPDATE_PENDING = 'MARKED_AS_COMPLETED_UPDATE_PENDING'
export const MARKED_AS_COMPLETED_UPDATE_FULFILLED = 'MARKED_AS_COMPLETED_UPDATE_FULFILLED'
export const MARKED_AS_COMPLETED_UPDATE_REJECTED = 'MARKED_AS_COMPLETED_UPDATE_REJECTED'
